// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import Tabs from '../Tabs';

const Wrapper = styled.div`
  padding: 0.5em 0.5em;
`;

const FILTER_TAB_HEIGHT = 2;

const StarterFilterTypes = {
  ONLY_STARTER: 'only-starter',
  ALL: 'all',
};

type MatchGroupStarterFiltersProps = {
  showOnlyStarters: boolean;
  onStarterFilterClick: (onlyStarters: boolean) => void;
};

const MatchGroupStarterFilters = ({ showOnlyStarters, onStarterFilterClick }: MatchGroupStarterFiltersProps) => {
  const tabs = useMemo(
    () => [
      { id: StarterFilterTypes.ONLY_STARTER, label: __('Starters') },
      { id: StarterFilterTypes.ALL, label: __('All players') },
    ],
    [],
  );
  const selected = useMemo(
    () => (showOnlyStarters ? StarterFilterTypes.ONLY_STARTER : StarterFilterTypes.ALL),
    [showOnlyStarters],
  );

  const onFilterChange = useCallback(
    (selectedId) => {
      onStarterFilterClick(selectedId === StarterFilterTypes.ONLY_STARTER);
    },
    [onStarterFilterClick],
  );

  return (
    <Wrapper>
      <Tabs tabs={tabs} selected={selected} onSelectionChange={onFilterChange} tabHeight={FILTER_TAB_HEIGHT} />
    </Wrapper>
  );
};

export default MatchGroupStarterFilters;
